
import { gql } from "graphql-tag";
import { documentLink, externalLink } from "~/app/prismic/prismic-fragments";

const PAYMENT_ICONS_QUERY = gql`
  query payment_icon($uid: String!, $lang: String = "en-in") {
    payment_icon(uid: $uid, lang: $lang) {
      icon_list {
        icon_name
        icon_link {
          ...documentLink
          ...externalLink
        }
      }
    }
  }
  ${documentLink}
  ${externalLink}
`;

export default {
  props: {
    price: { type: String, default: "0" },
  },

  data() {
    return {
      paymentIcons: [
        {
          src: "Afterpay_Logo_BNLP.svg",
          alt: "Afterpay logo",
          width: "71",
          height: "16",
          top: "9",
          right: "5",
        },
        {
          src: "pay-logo.svg",
          class: "m-auto",
          alt: "Pay logo",
          width: "90",
          height: "16",
          top: "1",
          right: "-1",
        },
        {
          src: "Humm_Logo_BNLP.svg",
          alt: "Humm logo bnlp",
          class: "m-auto",
          width: "75",
          height: "16",
          top: "10",
          right: "15",
        },
      ],
    };
  },

  async fetch() {
    const data = await this.$prismicGql.request({
      query: PAYMENT_ICONS_QUERY,
      variables: { uid: "paymenticons" },
    });

    const newPaymentIcons = this.reCreateIcons(data.payment_icon.icon_list);
    if (newPaymentIcons.length) {
      this.paymentIcons = newPaymentIcons;
    }
  },

  fetchOnServer: false,

  computed: {
    productPrice() {
      return Number(this.price) || 0;
    },
  },

  methods: {
    reCreateIcons(serverIcons) {
      let paymentIcons = [];
      for (let { icon_name: name, icon_link: link } of serverIcons) {
        let foundIcon = this.paymentIcons.find(({ alt }) => {
          let iconName = name.split(/(card|-)/);
          if (iconName.length) {
            return alt.toLowerCase().startsWith(iconName[0] + " ");
          }
          return false;
        });
        if (foundIcon) {
          paymentIcons.push({ ...foundIcon, link });
        }
      }
      const iconToBeSwaped = paymentIcons[2];
      paymentIcons[2] = paymentIcons[1];
      paymentIcons[1] = iconToBeSwaped;

      return paymentIcons;
    },
    getImage({ src, alt, width, height }) {
      return {
        src,
        alt,
        width,
        height,
        provider: "ipx",
      };
    },
  },
};
